
import id from 'fn/id.js';

export const name    = 'identity';
export const apply   = id;
export const unapply = id;
export const BYTES   = 1; // Uint8 name
